import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = err => {
	const errorMsg = err?.response?.data?.message || err?.response?.data?.error;
	const status = err?.response?.status;

	if (
		errorMsg === "ERR_SESSION_EXPIRED" ||
		status === 401 ||
		status === 403 ||
		err?.message === "canceled" ||
		err?.name === "CanceledError"
	) {
		return;
	}

	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		}
	} else if (err?.message && err.message !== "Network Error") {
		toast.error(err.message);
	}
};

export default toastError;
